exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.profile-background[data-v-ad53ff5e]{background-color:silver\n}\n.cropper-logo[data-v-ad53ff5e]{max-height:350px;width:100%;background-color:#ddd\n}", ""]);

// exports
